import {
  isArray, isFunction, filter, includes, flatten,
} from 'lodash';
import $ from 'jquery';

export default class Dispatcher {
  constructor(handles) {
    this.handlers = handles || {};
  }

  static executeComponent(c) {
    const component = c;

    // Callbacks
    if (isFunction(component.init)) {
      component.init();
    }

    if (isFunction(component.domready)) {
      $(component.domready.bind(component));
    }
  }

  dispatch(handles) {
    if (handles.indexOf('_always_') < 0) handles.unshift('_always_');
    const handlers = this.getHandlers(handles);

    const lazyHandlers = flatten(
      handlers.map(
        handlerArray => filter(handlerArray, isFunction),
      ),
    );

    Promise.all(lazyHandlers.map(fn => fn())).then((loadedHandlers) => {
      flatten(handlers).forEach((handler) => {
        let componentHandler = handler;
        if (isFunction(handler)) {
          const HandlerClass = loadedHandlers.shift().default;
          if (typeof HandlerClass === 'function') {
            componentHandler = new HandlerClass();
          }
        }
        this.constructor.executeComponent(componentHandler);
      });
    });
  }

  getHandlers(handles) {
    return filter(this.handlers, (v, k) => includes(handles, k))
      .map(handler => (isArray(handler) ? handler : [handler]));
  }
}

